module.exports = __webpack_public_path__ + "static/img/1.319f8c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/1.jpg
// module id = lZl/
// module chunks = 0